import React from 'react';
import { Nav } from 'rsuite';

import './styles.css';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite/esm/Nav/NavMenu').NavMenuProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomNavMenu({ children, icon, title, subtitle, ...rest }) {
  const renderedTitle = (
    <div className="custom-navMenu-titleRow">
      {icon && <div className="custom-navMenu-iconChip">{icon}</div>}
      <div className="custom-navMenu-titleText">
        <div className="custom-navMenu-titleMain">{title}</div>
        {subtitle && <div className="custom-navMenu-titleSub">{subtitle}</div>}
      </div>
    </div>
  );

  return (
    <Nav.Menu {...rest} title={renderedTitle} className="custom-navMenu">
      {children}
    </Nav.Menu>
  );
}
